import { useUser } from '@clerk/clerk-react';
import { Navigate, useLocation } from '@tanstack/react-router';
import DashboardWrapper from '../../layout/DashboardWrapper';

// PrivateRoute renders children immediately (even before Clerk isLoaded)
// so cached query data can be displayed instantly. It now ensures the
// `DashboardWrapper` is present for private pages so the chrome is consistent.
const PrivateRoute = ({ children }) => {
    const { isSignedIn, isLoaded } = useUser();
    const location = useLocation();

    if (isLoaded && !isSignedIn) {
        const currentPath = location.pathname;
        if (currentPath.startsWith('/sign-in') || currentPath.startsWith('/sign-up')) {
            return <Navigate to="/sign-in" replace />;
        }
        return <Navigate to="/sign-in" search={{ redirect: currentPath }} replace />;
    }

    // Wrap children with DashboardWrapper so private pages always have chrome.
    return <DashboardWrapper>{children}</DashboardWrapper>;
};

export default PrivateRoute;
